{
  "title": "Users",
  "subtitle": "List of users in your key account network.",
  "search": "Search a user",
  "filters": "Filters",
  "roleFilter": "Role",
  "statusFilter": "Status",
  "loadMore": "Load more",
  "table": {
    "network": "Network",
    "role": "Role",
    "user": "User",
    "applicant": "Applicant",
    "files": "Files",
    "groups": "Groups",
    "status": "Status",
    "infoQuality": "Info quality",
    "description": "Description",
    "other": "other",
    "others": "others"
  },
  "status": {
    "pending": "Pending",
    "inactive": "Inactive",
    "active": "Active",
    "deleted": "Deleted"
  },
  "infoQuality": {
    "missing": "Missing",
    "partial": "Partial",
    "complete": "Complete"
  }
}
